export var popular_photos = [{
  "id": "452181",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s1465_fl0377_it0004.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s1465_fl0377_it0004.jpg",
  "date": "1970",
  "title": "City Skyline from Leslie Street Spit, 1970s",
  "height": 143,
  "subtitle": ""
}, {
  "id": "141995",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0372_ss0041_it0387.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0372_ss0041_it0387.jpg",
  "date": "1935",
  "title": "Cherry Beach, 1935",
  "height": 145,
  "subtitle": ""
}, {
  "id": "135927",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1568_it0311.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1568_it0311.jpg",
  "date": "1903",
  "title": "Yonge & Temperance, 1903",
  "height": 137,
  "subtitle": ""
}, {
  "id": "144223",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0372_ss0079_it0334.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0372_ss0079_it0334.jpg",
  "date": "1928",
  "title": "Railyards, 1928",
  "height": 144,
  "subtitle": ""
}, {
  "id": "51505",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1244_it0246.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1244_it0246.jpg",
  "date": "1909",
  "title": "Crowds waiting to board ferry to Toronto Island, 1909",
  "height": 147,
  "subtitle": ""
}, {
  "id": "87294",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1244_it4535.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1244_it4535.jpg",
  "date": "1915",
  "title": "Flying boat, 1915",
  "height": 154,
  "subtitle": ""
}, {
  "id": "43271",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0071_it10259.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0071_it10259.jpg",
  "date": "1934",
  "title": "Congestion caused by double parking, 1934",
  "height": 151,
  "subtitle": ""
}, {
  "id": "229459",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1548_s0393_it0010.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1548_s0393_it0010.jpg",
  "date": "1940",
  "title": "Ice Boats, Toronto Harbour, pre-1940",
  "height": 127,
  "subtitle": ""
}, {
  "id": "430146",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f0124_fl0009_id0105.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f0124_fl0009_id0105.jpg",
  "date": "1972",
  "title": "Crowds at Ontario Place, 1972-1989",
  "height": 138,
  "subtitle": ""
}, {
  "id": "86674",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1244_it2468.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1244_it2468.jpg",
  "date": "1947",
  "title": "Queen Street West between Simcoe Street and University Avenue, 1926",
  "height": 152,
  "subtitle": ""
}, {
  "id": "95166",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0372_ss0003_it1419.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0372_ss0003_it1419.jpg",
  "date": "1909",
  "title": "Ontario Barber Shop, 1947",
  "height": 141,
  "subtitle": ""
}, {
  "id": "53175",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1244_it1537.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1244_it1537.jpg",
  "date": "1953",
  "title": "Scarborough Bluffs point, 1909",
  "height": 151,
  "subtitle": ""
}, {
  "id": "103794",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0372_ss0100_it0180.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0372_ss0100_it0180.jpg",
  "date": "1914",
  "title": "Queen Street West, 1953",
  "height": 142,
  "subtitle": ""
}, {
  "id": "87674",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1244_it7167.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1244_it7167.jpg",
  "date": "1911",
  "title": "Spadina Avenue, looking south from Queen Street, 1914",
  "height": 152,
  "subtitle": ""
}, {
//   Temporarily removed until we get a better location;
//   Ossington and St. Clair do not intersect in the modern street grid.
//   "id": "80850",
//   "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1231_it1736.jpg",
//   "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1231_it1736.jpg",
//   "date": "1900",
//   "title": "St. Clair Avenue west from Ossington Avenue, 1911",
//   "height": 147,
//   "subtitle": ""
// }, {
  "id": "135862",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1568_it0248.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1568_it0248.jpg",
  "date": "1900",
  "title": "St. Clair Avenue West, looking east from Dufferin Street, after 1900",
  "height": 161,
  "subtitle": ""
}, {
  "id": "96347",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0372_ss0058_it0191.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0372_ss0058_it0191.jpg",
  "date": "1913",
  "title": "University Avenue, South of College Street",
  "height": 147,
  "subtitle": ""
}, {
  "id": "81004",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1231_it1889.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1231_it1889.jpg",
  "date": "1913",
  "title": "Harbord Street bridge at Bickford Park Ravine",
  "height": 147,
  "subtitle": ""
}, {
  "id": "229496",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1548_s0393_it0253.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1548_s0393_it0253.jpg",
  "date": "1895",
  "title": "Horticultural Gardens (Allan Gardens) from rosary",
  "height": 146,
  "subtitle": ""
// Temporarily removed due to user feedback.
// }, {
//   "id": "50752",
//   "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/s0376_fl0003_it0012.jpg",
//   "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/s0376_fl0003_it0012.jpg",
//   "date": "1890",
//   "title": "Shaw Street bridge at Sully Crescent looking north",
//   "height": 170,
//   "subtitle": ""
}, {
  "id": "87650",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1244_it7143.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1244_it7143.jpg",
  "date": "1907",
  "title": "Bay Street, looking north to City Hall",
  "height": 274,
  "subtitle": ""
}, {
  "id": "306119",
  "image_url": "https://storage.googleapis.com/sidewalk-old-toronto/images/f1266_it22072.jpg",
  "thumbnail_url": "https://storage.googleapis.com/sidewalk-old-toronto/thumbnails/f1266_it22072.jpg",
  "date": "1930",
  "title": "Victoria Street, George Merritt, 8 years old,103 Bond Street",
  "height": 269,
  "subtitle": ""
}];



// WEBPACK FOOTER //
// js/popular-photos.js